import { render, staticRenderFns } from "./BaseSubmitModal.vue?vue&type=template&id=3c0d17d3&scoped=true"
import script from "./BaseSubmitModal.vue?vue&type=script&lang=js"
export * from "./BaseSubmitModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0d17d3",
  null
  
)

export default component.exports